import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Re-export auth selectors from @origo/auth
export {
    selectGdoToken,
    selectIsSignedIn,
    selectUser,
    selectSettings
} from '@origo/auth';

// Panel selectors
export const selectActiveLeftPanel = (state: RootState): string | null => state.panel.left;
export const selectActiveRightPanel = (state: RootState): string | null => state.panel.right;
